// Carregamento com cards (dono, 25/10/2026): enquanto a lista chega, a tela
// mostra os cartões de banner piscando no formato real (prévia + barra de
// ordem/switch), no lugar do texto "Carregando banners…".
// `formato="totem"`: prévia alta das mídias da tela de descanso.

import { Skeleton } from "../../../components/ui/skeleton";

export default function BannersCarregando({ quantos = 2, formato = "banner" }) {
  const previa = formato === "totem" ? "h-64 md:h-72" : "aspect-[7/2]";
  return (
    <div className="space-y-3" data-e2e="banners-carregando" aria-busy="true" aria-label="Carregando">
      {Array.from({ length: quantos }, (_, i) => (
        <div key={i} className="bg-card border border-border rounded-xl overflow-hidden">
          <Skeleton className={`w-full rounded-none ${previa}`} />
          <div className="flex items-center gap-3 p-3">
            <Skeleton className="h-3 w-6" />
            <Skeleton className="h-8 w-8 rounded-lg" />
            <Skeleton className="h-8 w-8 rounded-lg" />
            <Skeleton className="h-5 w-20 ml-auto" />
            <Skeleton className="h-9 w-9 rounded-lg" />
          </div>
        </div>
      ))}
    </div>
  );
}
